import React from 'react';
import { CONTACT_FORM_URL, GOOGLE_FORM_URL } from './AppConstant';

const servicesData = [
  {
    icon: 'fas fa-code',
    title: 'Software Development',
    description: 'Understand user needs and habits.',
    delay: '.3s',
    isContact: true,
  },
  {
    icon: 'fas fa-mobile-alt',
    title: 'Mobile App Development',
    description: 'Mobile app user trend analysis.',
    delay: '.5s',
    isContact: false,
  },
  {
    icon: 'fas fa-globe',
    title: 'Web App Development',
    description: 'Creating dynamic web applications.',
    delay: '.7s',
    isContact: true,
  },
  {
    icon: 'fas fa-user-secret',
    title: 'Blockchain Development Company',
    description: 'Creating Blockchain Apps.',
    delay: '.3s',
    isContact: false,
  },
  {
    icon: 'fas fa-coins',
    title: 'Cryptocurrency Development',
    description: 'Creating Crypto Web & Apps',
    delay: '.5s',
    isContact: false,
  },
  {
    icon: 'fas fa-lightbulb',
    title: 'MVP Development',
    description: 'Build MVP Development',
    delay: '.5s',
    isContact: false,
  },
  {
    icon: 'fas fa-building',
    title: 'Enterprise Software Development',
    description: 'Measure B2B Scope',
    delay: '.5s',
    isContact: false,
  },
  {
    icon: 'fas fa-pencil-ruler',
    title: 'UX/UI Designing',
    description: 'Creating User centric design',
    delay: '.5s',
    isContact: false,
  },
  {
    icon: 'fas fa-robot',
    title: 'AI Development Services',
    description: 'Implementing AI in softwares',
    delay: '.5s',
    isContact: false,
  },
  {
    icon: 'fas fa-user-cog',
    title: 'Hire Software Developers',
    description: 'Hire Top Talent as per need',
    delay: '.5s',
    isContact: false,
  },
  {
    icon: 'fas fa-bullhorn',
    title: 'Digital Marketing',
    description: 'Boost brand awareness & conversions',
    delay: '.5s',
    isContact: false,
  },
  {
    icon: 'fas fa-users-cog',
    title: 'IT Staff Augmentation',
    description: 'Flexible hiring to scale',
    delay: '.7s',
    isContact: true,
  },
];


const Services = () => {
  return (
    <div className="container-fluid services py-5 mb-5">
      <div className="container">
        <div
          className="text-center mx-auto pb-5 wow fadeIn"
          data-wow-delay=".3s"
          style={{ maxWidth: '600px' }}
        >
          <h5 className="text-primary">Our Services</h5>
          <h1>Services Built Specifically For Your Business</h1>
        </div>
        <div className="row g-5 services-inner">
          {servicesData.map((service, index) => (
            <div
              className="col-md-6 col-lg-4 wow fadeIn"
              data-wow-delay={service.delay}
              key={index}
            >
              <div className="services-item bg-light">
                <div className="p-4 text-center services-content">
                  <div className="services-content-icon">
                    <i className={`fa ${service.icon} fa-7x mb-4 text-primary`}></i>
                    <h4 className="mb-3">{service.title}</h4>
                    <p className="mb-4">{service.description}</p>
                    {/* <a
                      href={service.isContact ? CONTACT_FORM_URL : GOOGLE_FORM_URL}
                      className="btn btn-secondary text-white px-5 py-3 rounded-pill"
                      target="_blank" 
                      rel="noopener noreferrer"
                    >
                      {service.isContact ? 'Contact' : 'Apply'}
                    </a> */}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
